import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const plicometryApi = createApi({
  reducerPath: 'plicometrie',
  tagTypes: ['Plicometry'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchPlicometries: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Plicometry', id: 'LIST' },
                ...result.map((r) => ({ type: 'Plicometry', id: r.id })),
              ]
            : [{ type: 'Plicometry', id: 'LIST' }],
        query: () => ({
          url: '?resource=plicometry',
          method: 'GET',
        }),
      }),

      createPlicometry: builder.mutation({
        invalidatesTags: [{ type: 'Plicometry', id: 'LIST' }],
        query: (data) => ({
          url: '?resource=plicometry',
          method: 'POST',
          body: data,
        }),
      }),

      updatePlicometry: builder.mutation({
        invalidatesTags: (result, error, { id: plicometryId }) => [
          { type: 'Plicometry', id: plicometryId },
          { type: 'Plicometry', id: 'LIST' },
        ],
        query: ({ id: plicometryId, submitData }) => ({
          url: `?resource=plicometry&id=eq.${plicometryId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),

      fetchPlicometry: builder.query({
        providesTags: (result, error, arg) => [{ type: 'Plicometry', id: arg }],
        query: (plicometryId) => ({
          url: `?resource=plicometry&id=eq.${plicometryId}`,
          method: 'GET',
        }),
      }),

      fetchPlicometryByAtheleteId: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Plicometry', id: 'LIST' },
                ...result.map((r) => ({ type: 'Plicometry', id: r.id })),
              ]
            : [{ type: 'Plicometry', id: 'LIST' }],
        query: (athleteId) => ({
          url: `?resource=plicometry&athlete=eq.${athleteId}&order=date.desc`,
          method: 'GET',
        }),
      }),
    };
  },
});

export const {
  useFetchPlicometriesQuery,
  useCreatePlicometryMutation,
  useUpdatePlicometryMutation,
  useFetchPlicometryQuery,
  useFetchPlicometryByAtheleteIdQuery,
} = plicometryApi;

export { plicometryApi };
